export const THREAD_FINALIZED_SUB_HEADING =
  'This thread has been locked for publishing and cannot be edited. Please contact a member of the Blue Robot team if you need to make any changes.'

export const THREAD_FINALIZED_TOOLTIP =
  'This thread is in production and cannot be edited. You can still view this thread and share it. If you need to unlock and edit this thread, please contact the Blue Robot team.'

export const THREAD_FINALIZE_MODAL_PARAGRAPH =
  'Finalising this thread will send it into production and lock this thread, meaning you will not be able to edit it. Are you sure you want to proceed?'

export const THREAD_UNLOCK_MODAL_PARAGRAPH =
  'Unlocking this thread will allow users with write access to edit this thread again. Are you sure you want to proceed?'
